<template>
    <div class="main-layout">
        <div class="main-header">
            <header class="container">
                <img src="@/assets/img/upmood_logo.svg" alt="Upmood" class="logo">

                <section @click="toggleOptions = !toggleOptions">
                    {{ user.first_name + ' ' + user.last_name }}
                    <img src="@/assets/img/avatar-default.png" alt="" class="avatar">

                    <div class="options" v-if="toggleOptions">
                        <button @click="$store.dispatch('auth/signOut')">{{ $t('logout') }}</button>
                    </div>
                </section>
            </header>

            <nav class="container">
                <router-link v-for="({name, icon}, index ) in routes" :key="index" :to="{ name }">
                    <img :src="icon" alt="">
                    {{ name }}
                </router-link>
            </nav>
        </div>

        <main>
            <div class="container">
                <slot></slot>
            </div>
        </main>
        <AppFooter/>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
	data () {
		return {
			toggleOptions: false
		}
	},

	computed: {
		...mapFields('auth', ['user']),

		routes () {
			return [
				{
					name: this.$t('routers'),
					icon: require('@/assets/img/signal-alt.svg')
				}
			]
		}
	},

	methods: {
		logout () {
			this.toggleOptions = false
		}
	}
}
</script>

<style lang="scss" scoped>
.main-layout {
    background-color: #F5F6FA;
    height: 100%;
    display: flex;
    flex-direction: column;

    .main-header {
        background-color: #fff;
        box-shadow: 0 2px 6px #0000000A;

        header {
            padding: .5rem 1.5rem;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .logo {
                width: 6rem;
            }
        }

        .avatar {
            margin-left: 1rem;
            border-radius: 50%;
            width: 3rem;
        }

        section {
            cursor: pointer;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            position: relative;
        }

        .options {
            position: absolute;
            top: 2rem;
            left: 1rem;
            margin-top: 1rem;
            background-color: #fff;
            box-shadow: 0 0.15rem 0.3rem #aaa;

            button {
                color: #d18383;
                padding: 0.5rem 2rem;
            }
        }

        nav {
            padding: .5rem 1.5rem;

            a {
                display: flex;
                align-items: center;
                text-transform: capitalize;

                img {
                    width: 1rem;
                    margin-right: .5rem;
                }
            }
        }
    }

   main {
        width: 100%;
        height: 100%;
        flex: 1 1 auto;
        overflow: auto;

        .container {
            padding: 4rem 1.5rem;
            height: 100%;
            width: 100%;
        }
    }

    .app-footer {
        padding: 0.5rem 1.5rem;
        width: 100%;
        font-size: 12px;
        font-weight: 600;
    }
}
</style>
